export default {
  // 页面标题和欢迎信息
  welcome: {
    title: '欢迎回来，{name}！',
    titleWithoutName: '欢迎回来！',
    wave: '👋'
  },
  
  // 按钮和操作
  actions: {
    createCampaign: '创建新的营销计划'
  },
  
  // 页面描述
  description: '查看活动报告与分析',
  
  // 通用状态
  status: {
    loading: '加载中…',
    error: '发生错误',
    success: '成功'
  }
};
